import getOrderItemPrice from './getOrderItemPrice';


export default function setOrderItemPrice(orderItem) {
	Object.assign(orderItem, getOrderItemPrice(orderItem));
}
